// An address as said on a screen, each part once (Liam, 26 Oct 2026, Sarah's payment message: "52 Windsor Road, N13 5PR,
// N13 5PR"): an address saved with its postcode already in it, then joined to the postcode again, says it twice. Parts
// are the same when they read the same, case and spaces aside. Nothing is changed on the customer: only the words shown.
export function tidyAddress(address: string | null | undefined): string {
  const seen = new Set<string>()
  const out: string[] = []
  for (const part of String(address ?? '').split(',')) {
    const t = part.trim()
    const k = t.toUpperCase().replace(/\s+/g, '')
    if (!t || seen.has(k)) continue
    seen.add(k)
    out.push(t)
  }
  return out.join(', ')
}

// An address with its postcode, the postcode left off when the address already ends with it (case and spaces aside), each
// part once. Every screen that writes "address, postcode" uses this (GPT-6.1 and Sonnet found the same join in 20 places,
// 26 Oct 2026). functions/lib/address-words.ts is the server's copy.
export function addressLine(address: string | null | undefined, postcode: string | null | undefined, sep = ', '): string {
  const a = tidyAddress(address)
  const pc = String(postcode ?? '').trim()
  const flat = (x: string): string => x.toUpperCase().replace(/\s+/g, '')
  const has = !!pc && flat(a).includes(flat(pc))
  return [a, has ? '' : pc].filter(Boolean).join(sep)
}
